/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Radio } from "antd";
import ChevronIcon from "../../../../Common/Svgs/ChevronIcon";
import CustomInput from "../../../../Core/Components/CustomInput";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import CustomTags from "../../../../Core/Components/CustomTags";
import { updateRequest } from "../../../../Redux/Slices/requests.slice";
import { client } from "../../../../Utils/axiosClient";
import useDebounce from "../../../../Core/hooks/useDebounce";
import TrikeIcon from "../../../../Common/Svgs/TrikeIcon";

const SelectTrike = () => {
  const dispatch = useDispatch();

  const { currentRental } = useSelector((state) => state.rentals);
  const { rentalAssigning } = useSelector((state) => state.requests);

  const [search, setSearch] = useState("");
  const [focus, setFocus] = useState(false);
  const [trikes, setTrikes] = useState([]);

  const debounceSearch = useDebounce(search, 500);

  const handleSelection = (trike) => {
    if (+trike.id === rentalAssigning?.trikeId) {
      dispatch(
        updateRequest({
          key: "rentalAssigning",
          value: {
            ...rentalAssigning,
            trikeId: 0,
            trikeRegistrationNo: "",
            vehicleType: "",
          },
        })
      );
    } else {
      dispatch(
        updateRequest({
          key: "rentalAssigning",
          value: {
            ...rentalAssigning,
            trikeId: +trike.id,
            trikeRegistrationNo: trike.registrationNo,
            vehicleType: trike?.vehicleType?.toLowerCase() || "",
          },
        })
      );
    }
  };

  const getRentalTrikes = useCallback(
    async (params) => {
      try {
        dispatch(updateRequest({ key: "loading", value: true }));

        const response = await client.get(
          `${process.env.REACT_APP_API_URL}/rentals/get-trikes`,
          { params }
        );

        if (response.status === 200) {
          setTrikes([...response.data.result]);
        }
      } catch (error) {
        console.log(error);
        setTrikes([]);
      } finally {
        dispatch(updateRequest({ key: "loading", value: false }));
      }
    },
    [dispatch]
  );

  useEffect(() => {
    const params = {
      hubId: currentRental?.hubId || 0,
      ownerId: currentRental?.driverId || 0,
    };

    if (debounceSearch) params.searchQuery = debounceSearch;

    getRentalTrikes(params);
  }, [getRentalTrikes, debounceSearch, currentRental]);

  return (
    <div className="bg-background-white h-full px-6">
      <div className="py-6 flex items-center gap-x-3 border-t border-light-grey">
        <button
          type="button"
          onClick={() =>
            dispatch(
              updateRequest({
                key: "transportDetailStep",
                value: 1,
              })
            )
          }
        >
          <ChevronIcon className="w-5 h-5 stroke-dark-gray -rotate-180" />
        </button>

        <p className="font-poppins font-medium text-sm text-black">
          Assign a vehicle to accept this request
        </p>
      </div>

      <CustomInput
        intent="searchFilterItem"
        prefix={<img src="/assets/icons/search.svg" alt="" className="mr-2" />}
        value={search}
        focus={focus}
        border={focus ? "success" : "none"}
        placeholder={focus ? null : "Search Trike No."}
        onChange={(e) => setSearch(e.target.value)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        suffix={
          search.length > 0 ? (
            <CloseIcon
              className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
              onClick={() => {
                setFocus(false);
                setSearch("");
              }}
            />
          ) : null
        }
      />

      <div className="">
        {trikes?.length ? (
          trikes.map((trike) => (
            <div
              className={`flex items-center justify-between h-10 px-6 border-b cursor-pointer hover:bg-primary-20 border-light-grey 
            ${trike.id === rentalAssigning?.trikeId ? "bg-primary-20" : ""}`}
              key={trike.id}
              onClick={() => handleSelection(trike)}
            >
              <div className="flex items-center gap-x-3">
                <Radio checked={trike.id === rentalAssigning?.trikeId} />
                <p className="text-xs font-semibold text-black capitalize font-aileron">
                  {trike?.registrationNo}
                </p>
              </div>

              {trike?.ownerId && (
                <CustomTags colors="onATrip" background="onATrip">
                  <p className="text-xs font-medium font-poppins">Leased</p>
                </CustomTags>
              )}
              <CustomTags colors="checkIn" background="checkIn">
                <p className="text-xs font-medium font-poppins">Available</p>
              </CustomTags>
            </div>
          ))
        ) : (
          <div
            className="w-full flex items-center justify-center"
            style={{ height: "200px" }}
          >
            <div className="flex flex-col gap-y-1.5 items-center justify-center">
              <div className="flex items-center justify-center h-full">
                <div className="w-9.5 h-9.5 bg-light-grey rounded-full flex items-center justify-center">
                  <TrikeIcon size={16} className="text-dark-gray" />
                </div>
              </div>

              <p className="font-light text-10 leading-3.75 font-poppins text-dark-grey-text">
                Nothing to show
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectTrike;
